"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.bgBlack = exports.container = exports.titleStyle = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Start of styles for other stories in elements
var titleStyle = process.env.NODE_ENV === "production" ? {
  name: "16laz0r",
  styles: "color:#6187e0;display:flex;padding-bottom:0.5rem;border-bottom:1px solid #e4e8ed"
} : {
  name: "1qca0qi-titleStyle",
  styles: "color:#6187e0;display:flex;padding-bottom:0.5rem;border-bottom:1px solid #e4e8ed;label:titleStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
exports.titleStyle = titleStyle;
var container = process.env.NODE_ENV === "production" ? {
  name: "sda5lk",
  styles: "margin-bottom:2rem;&&>*{margin:1rem;}"
} : {
  name: "18nvd6a-container",
  styles: "margin-bottom:2rem;&&>*{margin:1rem;};label:container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
exports.container = container;
var bgBlack = process.env.NODE_ENV === "production" ? {
  name: "1eubofd",
  styles: "background-color:#000;padding:5px 0"
} : {
  name: "tw43wj-bgBlack",
  styles: "background-color:#000;padding:5px 0;label:bgBlack;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}; // End of styles for other stories in elements

exports.bgBlack = bgBlack;

var textNormal = function textNormal(theme) {
  return /*#__PURE__*/(0, _react.css)("line-height:", theme.lineHeight.leadingNormal, ";color:", theme.color.monochrome.black, ";font-size:", theme.fontSize.x2large, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textNormal;"));
}; // font weight


var fontNormal = function fontNormal(theme) {
  return /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.normal, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:fontNormal;"));
};

var fontMedium = function fontMedium(theme) {
  return /*#__PURE__*/(0, _react.css)("font-weight:", theme.fontWeight.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:fontMedium;"));
}; // color


var textBlack = function textBlack(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.black, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textBlack;"));
};

var textSuperDark = function textSuperDark(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.superDark, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textSuperDark;"));
};

var textDark = function textDark(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.dark, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textDark;"));
};

var textMediumDark = function textMediumDark(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.mediumDark, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textMediumDark;"));
};

var textPrimary = function textPrimary(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.brand, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textPrimary;"));
};

var textPositive = function textPositive(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.positive, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textPositive;"));
};

var textNegative = function textNegative(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.negative, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textNegative;"));
};

var textWarning = function textWarning(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.warningText, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textWarning;"));
};

var textNegativeAlt = function textNegativeAlt(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.primary.negativeAlt, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textNegativeAlt;"));
};

var textWhite = function textWhite(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textWhite;"));
}; // Letter spacing


var letterSpacing0 = function letterSpacing0(theme) {
  return /*#__PURE__*/(0, _react.css)("letter-spacing:", theme.spacing[0], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:letterSpacing0;"));
};

var letterSpacing1 = function letterSpacing1(theme) {
  return /*#__PURE__*/(0, _react.css)("letter-spacing:", theme.spacing[1], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:letterSpacing1;"));
}; // font size, line height, letter-spacing


var textSm = function textSm(theme) {
  return /*#__PURE__*/(0, _react.css)(textNormal(theme), " font-size:", theme.fontSize.large, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textSm;"));
};

var textXs = function textXs(theme) {
  return /*#__PURE__*/(0, _react.css)(textNormal(theme), " font-size:", theme.fontSize.base, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textXs;"));
};

var text2Xs = function text2Xs(theme) {
  return /*#__PURE__*/(0, _react.css)(textNormal(theme), " font-size:", theme.fontSize.small, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:text2Xs;"));
};

var text3Xs = function text3Xs(theme) {
  return /*#__PURE__*/(0, _react.css)(textNormal(theme), " font-size:", theme.fontSize.xsmall, ";letter-spacing:", theme.spacing[0], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:text3Xs;"));
};

var textTiny = function textTiny(theme) {
  return /*#__PURE__*/(0, _react.css)(textNormal(theme), " font-size:", theme.fontSize.tiny, ";letter-spacing:", theme.spacing[0], ";" + (process.env.NODE_ENV === "production" ? "" : ";label:textTiny;"));
}; // Font style: italic


var italic = process.env.NODE_ENV === "production" ? {
  name: "1jwcxx3",
  styles: "font-style:italic"
} : {
  name: "2acfoi-italic",
  styles: "font-style:italic;label:italic;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var uppercase = process.env.NODE_ENV === "production" ? {
  name: "50zrmy",
  styles: "text-transform:uppercase"
} : {
  name: "1x2qsb1-uppercase",
  styles: "text-transform:uppercase;label:uppercase;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  textNormal: textNormal,
  fontNormal: fontNormal,
  fontMedium: fontMedium,
  textBlack: textBlack,
  textSuperDark: textSuperDark,
  textDark: textDark,
  textMediumDark: textMediumDark,
  textPrimary: textPrimary,
  textPositive: textPositive,
  textNegative: textNegative,
  textWarning: textWarning,
  textNegativeAlt: textNegativeAlt,
  textWhite: textWhite,
  letterSpacing0: letterSpacing0,
  letterSpacing1: letterSpacing1,
  textSm: textSm,
  textXs: textXs,
  text2Xs: text2Xs,
  text3Xs: text3Xs,
  textTiny: textTiny,
  italic: italic,
  uppercase: uppercase
};
exports.styles = styles;
//# sourceMappingURL=text.styles.js.map